<div class="container-fluid mt-3 px-4" style="font-size: 0.88rem;">
  
  <!-- Encabezado Estilizado Homologado -->
  <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
    <div>
      <h2 class="h5 m-0 fw-bold text-dark">Órdenes de Trabajo en Rampa (Mecánica)</h2>
      <span class="small text-muted font-monospace">JDE Service Order Matrix / Production Execution</span>
    </div>
  </div>

  <!-- 🔍 Barra de Búsqueda Reactiva Multi-Atributo -->
  <div class="card mb-3 border-0 shadow-sm bg-light">
    <div class="card-body p-2">
      <div class="input-group input-group-sm">
        <span class="input-group-text bg-white border-end-0">🔍</span>
        <input type="text" class="form-control border-start-0 ps-0 text-uppercase" 
               [(ngModel)]="filtroTexto" (input)="filtrarOrdenes()" 
               placeholder="Buscar orden de trabajo por Folio JDE, Técnico Asignado, Estado Operativo...">
      </div>
    </div>
  </div>

  <!-- 📊 Tabla de Órdenes de Trabajo -->
  <table class="table table-hover table-striped border shadow-sm align-middle">
    <thead class="table-dark">
      <tr>
        <th scope="col" style="width: 140px;">ID ORDEN</th>
        <th scope="col" style="width: 140px;">ID RECEPCIÓN</th>
        <th scope="col">AN8 TÉCNICO</th>
        <th scope="col" class="text-center">ESTATUS OPERATIVO</th>
        <th scope="col" class="text-center">ESTADO ADMINISTRATIVO</th>
        <th scope="col" class="text-center" style="width: 160px;">ACCIONES</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let c of ordenesPaginadas">
        <!-- 🚀 CORREGIDO: Se muestra el ID real correlativo de la Serviceorder -->
        <th scope="row" class="font-monospace text-primary fw-bold">
          #{{ c.id }}
        </th>
        <!-- 🚀 CORREGIDO: Se muestra el ID de la recepción de patio asociada -->
        <td class="text-uppercase fw-semibold text-secondary">
          REC-{{ c.idRecepcion.toString().padStart(8, '0') }}
        </td>
        <!-- 🚀 CORREGIDO: Se evalúa y muestra el AN8 del mecánico asignado -->
        <td class="text-uppercase fw-semibold" [ngClass]="c.an8Tecnico ? 'text-secondary' : 'text-danger font-monospace small'">
          {{ c.an8Tecnico ? 'MEC-' + c.an8Tecnico : '⚠️ SIN MECÁNICO ASIGNADO' }}
        </td>
<td class="text-center">
  <!-- 🎨 SOLUCIÓN COMPILACIÓN: Se unificaron las llaves repetidas en una sola línea usando el operador || -->
  <span class="badge font-monospace fw-bold px-2.5 py-1.5 align-middle shadow-sm border"
        [ngClass]="{
          'bg-danger-subtle text-danger-emphasis border-danger-subtle': c.orderStatus === 'PEND_ASIG' || c.orderStatus === 'PENDIENTE' || c.orderStatus === 'EN_RAMPA',
          'bg-secondary-subtle text-secondary-emphasis border-secondary-subtle': c.orderStatus === 'EN_PROGRESO',
          'bg-info-subtle text-info-emphasis border-info-subtle': c.orderStatus === 'PINTURA',
          'bg-success-subtle text-success-emphasis border-success-subtle': c.orderStatus === 'TERMINADO' || c.orderStatus === 'CONCLUIDO'
        }" style="font-size: 0.72rem; border-radius: 6px; letter-spacing: 0.3px;">
    
    <!-- ⏳ Iconos dinámicos en la barra de estados -->
    @if (c.orderStatus === 'PEND_ASIG' || c.orderStatus === 'PENDIENTE') {
      <span class="me-1">⏳</span>
    } @else if (c.orderStatus === 'EN_PROGRESO') {
      <span class="me-1">📦</span>
    } @else if (c.orderStatus === 'EN_RAMPA') {
      <span class="me-1">🔧</span>
    } @else if (c.orderStatus === 'PINTURA') {
      <span class="me-1">🎨</span>
    } @else if (c.orderStatus === 'TERMINADO' || c.orderStatus === 'CONCLUIDO') {
      <span class="me-1">🏁</span>
    }

    <!-- 🎯 COMPORTAMIENTO DE TEXTO RESTAURADO: Combinado para EN_PROGRESO, limpio para los demás -->
    @switch (c.orderStatus) {
      @case ('PEND_ASIG') {
        <span>PENDIENTE ASIGNAR</span>
      }
      @case ('PENDIENTE') {
        <span>PENDIENTE ASIGNAR</span>
      }
      @case ('EN_PROGRESO') {
        <span>EN_PROGRESO 👨‍🔧 Técnico Asignado</span>
      }
      @default {
        <span>{{ (c.orderStatus || 'N/A') | uppercase }}</span>
      }
    }
    
  </span>
</td>
<!--    <td class="text-center">
          <span class="badge bg-secondary font-monospace px-2 py-1 small text-uppercase">
            {{ c.status || 'ABIERTA' }}
          </span>
        </td> -->
        
        <!-- 🔧 COLUMNA: ESTADO EN RAMPA / FÍSICO (status) -->
<!--         <td class="text-center">
          <span class="badge font-monospace fw-bold px-2.5 py-1.5 align-middle"
                [ngClass]="{
                  'so-physical-open': c.status === 'ABIERTA',
                  'so-physical-rampa': c.status === 'EN_RAMPA',
                  'so-physical-pintura': c.status === 'PINTURA',
                  'so-physical-done': c.status === 'TERMINADA' || c.status === 'TERMINADO'
                }" style="font-size: 0.72rem; border-radius: 6px; border: 1px solid transparent; letter-spacing: 0.3px;">
             -->
            <!-- ✅ CORREGIDO: Se reemplazaron las etiquetas th:if por *ngIf nativo de Angular -->
<!--             <span class="me-1" *ngIf="c.status === 'ABIERTA'">📋</span>
            <span class="me-1" *ngIf="c.status === 'EN_RAMPA'">🔧</span>
            <span class="me-1" *ngIf="c.status === 'PINTURA'">🎨</span>
            <span class="me-1" *ngIf="c.status === 'TERMINADA' || c.status === 'TERMINADO'">🏁</span>
            
            {{ c.status || 'ABIERTA' | uppercase }}
          </span>
        </td> -->

        <!-- ESTATUS ADMINISTRATIVO CONTABLE (STATUS) -->
        <td class="text-center">
          <!-- 🎨 HOMOLOGACIÓN MATE: 'ABIERTA' toma el rojo sutil de PEND_ASIG y 'CERRADA' toma el verde sutil de TERMINADO -->
          <span class="badge font-monospace fw-bold px-2.5 py-1.5 align-middle shadow-sm border"
                [ngClass]="{
                  'bg-danger-subtle text-danger-emphasis border-danger-subtle': c.status === 'ABIERTA' || !c.status,
                  'bg-success-subtle text-success-emphasis border-success-subtle': c.status === 'CERRADA' || c.status === 'CONCLUIDO'
                }" style="font-size: 0.72rem; border-radius: 6px; letter-spacing: 0.3px;">
            
            <!-- Muestra el texto original en mayúsculas sin iconos -->
            {{ (c.status || 'ABIERTA') | uppercase }}
            
          </span>
        </td>        

        <td class="text-center">
          <div class="d-flex gap-2 justify-content-center">

            <!-- 🏁 BOTÓN DE ENTREGA CRUCIAL: Aparece sólo si la rampa terminó pero sigue abierta contablemente -->
            <button *ngIf="c.orderStatus === 'TERMINADO' && c.status === 'ABIERTA'" 
                    type="button" class="btn btn-sm btn-success py-1 px-2.5 fw-bold shadow-sm"
                    (click)="lanzarFirmaEntregaFinal(c)" style="font-size: 0.78rem;" title="Cerrar y Entregar Auto">
              🚗 Firmar Entrega
            </button>

            <button class="btn btn-sm btn-outline-secondary py-1 px-2" (click)="editServiceOrder(c)" style="font-size: 0.78rem;" title="Gestionar Orden">
              ⚙️ Gestionar
            </button>
            <button class="btn btn-sm btn-outline-danger py-1 px-2" (click)="deleteServiceOrder(c.id!)" style="font-size: 0.78rem;" title="Eliminar Registro">
              🗑️
            </button>
          </div>
        </td>
      </tr>
      <tr *ngIf="ordenesFiltradas.length === 0">
        <td colspan="6" class="text-center text-muted py-4">No se encontraron órdenes de servicio activas operando en las rampas de este taller.</td>
      </tr>
    </tbody>
  </table>

  <!-- 🧭 Paginador de Alta Velocidad Integrado -->
  <div class="d-flex justify-content-between align-items-center mt-3 border-top pt-2">
    <nav aria-label="Navegación de órdenes de trabajo">
      <ul class="pagination pagination-sm m-0 shadow-sm" style="border-radius: 6px; overflow: hidden; font-size: 0.82rem;">
        <li class="page-item" [class.disabled]="paginaActual === 1">
          <button type="button" class="page-link fw-bold text-dark border px-2.5" (click)="cambiarPagina(1)" title="Primera Página">⏮️</button>
        </li>
        <li class="page-item" [class.disabled]="paginaActual === 1">
          <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual - 1)">◀️ Anterior</button>
        </li>
        <li class="page-item disabled">
          <span class="page-link bg-light text-dark font-monospace border fw-bold px-3">
            PÁGINA {{ paginaActual }} DE {{ totalPaginas }}
          </span>
        </li>
        <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
          <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual + 1)">Siguiente ▶️</button>
        </li>
        <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
          <button type="button" class="page-link fw-bold text-dark border px-2.5" (click)="cambiarPagina(totalPaginas)" title="Última Página">⏭️</button>
        </li>
      </ul>
    </nav>

    <span class="text-muted small text-end font-monospace">
      Mostrando órdenes del <strong>{{ ((paginaActual - 1) * registrosPorPagina) + 1 }}</strong> 
      al <strong>{{ Math.min(paginaActual * registrosPorPagina, ordenesFiltradas.length) }}</strong> 
      de un total de <strong>{{ ordenesFiltradas.length }}</strong> registradas en el pipeline.
    </span>
  </div>

</div>

<router-outlet></router-outlet>